"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrTravelDatesInput = exports.FdrTravelDatesInputWrapper = exports.FdrTravelDatesMobileModalWrapper = exports.FdrWeekDaysListWrapper = exports.FdrFlexibleDurationDropdown = exports.FdrTravelDatesHeaderGroup = exports.FdrTravelDatesHeader = exports.FdrMonthIcon = exports.FdrRightDoubleChevronButton = exports.FdrLeftDoubleChevronButton = exports.FdrRightNavbarButton = exports.FdrLeftNavbarButton = exports.FdrDatePickerNavbarControl = exports.FdrDatePickerWrapper = exports.FdrTravelDatesInformationWrapper = exports.FdrApplyButtonWrapper = exports.FdrTravelDatesBottomPanel = exports.FdrTravelDatesWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const core_basis_bs_icon_1 = require("@hotelplan/core.basis.bs-icon");
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
const fdr_travel_dates_duration_dropdown_1 = require("./fdr-travel-dates-duration-dropdown");
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const components_common_inputs_1 = require("@hotelplan/components.common.inputs");
exports.FdrTravelDatesWrapper = styled_components_1.default.div({
    overflowY: 'auto',
});
exports.FdrTravelDatesBottomPanel = styled_components_1.default.div(({ theme }) => theme.travelDates.bottomPanelCss);
exports.FdrApplyButtonWrapper = (0, styled_components_1.default)(core_basis_bs_button_1.BsButton)({
    width: '100%',
    borderRadius: '0px',
});
exports.FdrTravelDatesInformationWrapper = styled_components_1.default.p((0, util_theme_sxc_1.sx2CssThemeFn)({
    textAlign: 'center',
    fontSize: [1, 2],
    color: [null, 'secondary'],
    p: [3, '9px'],
}));
exports.FdrDatePickerWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    mt: ['115px', 0],
}), ({ theme }) => theme.travelDates.travelDatesContainerCss);
exports.FdrDatePickerNavbarControl = styled_components_1.default.div(({ theme }) => theme.travelDates.navbarControlCss);
exports.FdrLeftNavbarButton = (0, styled_components_1.default)(core_basis_bs_button_1.BsButton).attrs({
    type: `button`,
})(({ canChangeYear }) => ({
    position: 'absolute',
    left: canChangeYear ? '50px' : '10px',
}));
exports.FdrRightNavbarButton = (0, styled_components_1.default)(core_basis_bs_button_1.BsButton).attrs({
    type: `button`,
})(({ canChangeYear }) => ({
    position: 'absolute',
    right: canChangeYear ? '50px' : '10px',
}));
exports.FdrLeftDoubleChevronButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon)((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    left: '10px',
}));
exports.FdrRightDoubleChevronButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon)((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    right: '10px',
}));
exports.FdrMonthIcon = (0, styled_components_1.default)(core_basis_bs_icon_1.BsIcon)(({ theme }) => theme.icons.lg);
exports.FdrTravelDatesHeader = styled_components_1.default.div(({ theme }) => theme.travelDates.headerCss);
exports.FdrTravelDatesHeaderGroup = styled_components_1.default.div(({ theme }) => theme.travelDates.headerGroupCss);
exports.FdrFlexibleDurationDropdown = (0, styled_components_1.default)(fdr_travel_dates_duration_dropdown_1.FdrTravelDatesDurationDropdown)({
    maxWidth: '200px',
    flex: 2,
});
exports.FdrWeekDaysListWrapper = styled_components_1.default.ul(({ theme }) => theme.travelDates.weekDaysListCss, (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    pt: 1,
    px: 3,
    pb: 3,
    '.weekDay': {
        flex: 1,
    },
}));
exports.FdrTravelDatesMobileModalWrapper = (0, styled_components_1.default)(components_common_modals_1.WhiteBoxModal)({
    '.modal-body': {
        overflowY: 'hidden',
    },
});
exports.FdrTravelDatesInputWrapper = styled_components_1.default.div(({ theme }) => theme.inputs.travelDatesWrapper);
exports.FdrTravelDatesInput = (0, styled_components_1.default)(components_common_inputs_1.BaseInput)(({ theme }) => theme.inputs.searchControlField);
//# sourceMappingURL=fdr-travel-dates.styles.js.map